import type { ParagraphWhyUs as ParagraphWhyUsData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "./ParagraphWhyUs.module.css";

/**
 * Layout 39 - `PARAGRAPH_WHY_US_LAYOUT`: dlaczego my / advantages grid.
 *
 * Struktura:
 *   - Eyebrow (text_1) - uppercase accent label nad tytulem
 *   - H2 (name) - tytul sekcji
 *   - Grid 3-kol z 9 slotow (kazdy: ikona w boxie + nazwa + opis)
 *   - Puste sloty (bez name i desc) filtrowane po backendzie
 */
export function ParagraphWhyUs({
  paragraph,
}: {
  paragraph: ParagraphWhyUsData;
  t: ParagraphTranslations;
}) {
  const { text_1: eyebrow, name: title, text: lead, items, color_variant: variant } = paragraph;
  const hasEyebrow = eyebrow && eyebrow.trim() !== "";
  const hasLead = lead && lead.trim() !== "";
  const hasItems = Array.isArray(items) && items.length > 0;

  return (
    <section className={styles.section} data-variant={variant ?? "default"}>
      <div className={styles.header}>
        {hasEyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
        {title ? <h2 className={styles.title}>{title}</h2> : null}
        {hasLead ? <p className={styles.lead}>{lead}</p> : null}
      </div>
      {hasItems ? (
        <div className={styles.grid}>
          {items.map((it, idx) => (
            <div key={idx} className={styles.card}>
              {it.icon ? (
                <div className={styles.iconBox} aria-hidden="true">
                  <i className={`nc-icon-outline ${it.icon}`} />
                </div>
              ) : null}
              {it.name ? <h3 className={styles.name}>{it.name}</h3> : null}
              {it.desc ? <p className={styles.desc}>{it.desc}</p> : null}
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
}
